export default {

  apiURL () {
    let apiURL = '';
    switch (window.location.hostname) {
      case 'localhost':
        // Please do not change this line.
        apiURL = 'https://dev-api.onlinepayment.io/';
        break;

      case 'dev-front.onlinepayment.io':
        apiURL = 'https://dev-api.onlinepayment.io/';
        break;

      case 'rc-front.onlinepayment.io':
        apiURL = 'https://rc-api.onlinepayment.io/';
        break;

      case 'front.onlinepayment.io':
        apiURL = 'https://api.onlinepayment.io/';
        break;

      case 'dev-front.sanalposentegrasyonu.com':
        apiURL = 'https://dev-api.sanalposentegrasyonu.com/';
        break;

      case 'front.sanalposentegrasyonu.com':
        apiURL = 'https://api.sanalposentegrasyonu.com/';
        break;

      default:
        console.error('API URL is not set.');
        return;
    }

    return apiURL;
  },

  rootURL () {
    let apiURL = '';
    switch (window.location.hostname) {
      case 'localhost':
        // Please do not change this line.
        apiURL = 'https://dev-front.onlinepayment.io/';
        break;

      case 'dev-front.onlinepayment.io':
        apiURL = 'https://dev-front.onlinepayment.io/';
        break;

      case 'rc-front.onlinepayment.io':
        apiURL = 'https://rc-front.onlinepayment.io/';
        break;

      case 'front.onlinepayment.io':
        apiURL = 'https://front.onlinepayment.io/';
        break;

      case 'dev-front.sanalposentegrasyonu.com':
        apiURL = 'https://dev-front.sanalposentegrasyonu.com/';
        break;

      case 'front.sanalposentegrasyonu.com':
        apiURL = 'https://front.sanalposentegrasyonu.com/';
        break;

      default:
        console.error('Data URL is not set.');
        return;
    }

    return apiURL;
  },

  isValidResponse (response) {
    if (response.data.status === 'OK') {
      return true;
    } else {
      return false;
    }
  },

  postRedirect (params, url) {
    let form = document.createElement('form');

    /**
     * Prevent safari bug
     *
     * Safari has some issues with the default submit function.
     * This is a workaround.
     */
    // form._submit_function_ = form.submit;
    form.setAttribute('method', 'POST');
    form.setAttribute('action', url);

    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        let hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);

        form.appendChild(hiddenField);
      }
    }

    document.body.appendChild(form);

    form.submit();

    /**
     * Prevent safari bug
     *
     * Call the secondary function manually.
     */
    // form._submit_function_();
  }
};



// WEBPACK FOOTER //
// ./src/api/utilities.js